module.exports = __webpack_public_path__ + "img/illu3.4b6b9b8a.png";